'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_io$002eintela$002esites$002edigitalinternship$002e$002dPage$0024$002dSegment$002dKey$0024 from "./io.intela.sites.digitalinternship.-Page$-Segment-Key$.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_data_Images$() {
  this.sR = null;
  this.mw = null;
  this.sW = null;
  this.sT = null;
  this.sU = null;
  this.sS = null;
  this.mx = null;
  this.sV = null;
  this.sQ = null;
  this.mv = null;
  $n_Lio_intela_sites_digitalinternship_data_Images$ = this;
  this.sR = "/images/home-maze.png";
  this.mw = "/images/home-solution-card.png";
  this.sW = "/images/students-solution-card.png";
  this.sT = "/images/parents-solution-card.png";
  this.sU = "/images/portfolio-radar.png";
  this.sS = "/images/how-it-works-workspace.png";
  this.mx = "/images/resources-featured.png";
  this.sV = "/images/resources-market-data.png";
  this.sQ = "/images/about-mission.png";
  this.mv = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("/images/blog/post-1.png", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("/images/blog/post-2.png", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("/images/blog/post-3.png", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("/images/blog/post-4.png", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("/images/blog/post-5.png", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("/images/blog/post-6.png", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))));
}
export { $c_Lio_intela_sites_digitalinternship_data_Images$ as $c_Lio_intela_sites_digitalinternship_data_Images$ };
$p = $c_Lio_intela_sites_digitalinternship_data_Images$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_digitalinternship_data_Images$;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_data_Images$() {
}
export { $h_Lio_intela_sites_digitalinternship_data_Images$ as $h_Lio_intela_sites_digitalinternship_data_Images$ };
$h_Lio_intela_sites_digitalinternship_data_Images$.prototype = $p;
$p.AV = (function(key) {
  return (("/images/hero-" + key.d2) + ".png");
});
$p.AW = (function(key) {
  return (("/images/section-" + key.d2) + "-impl.png");
});
$p.AX = (function(key) {
  var x = $j_io$002eintela$002esites$002edigitalinternship$002e$002dPage$0024$002dSegment$002dKey$0024.$s_Lio_intela_sites_digitalinternship_Page$SegmentKey$__Students__Lio_intela_sites_digitalinternship_Page$SegmentKey();
  if ((x === key)) {
    return this.sW;
  } else {
    var x$3 = $j_io$002eintela$002esites$002edigitalinternship$002e$002dPage$0024$002dSegment$002dKey$0024.$s_Lio_intela_sites_digitalinternship_Page$SegmentKey$__Parents__Lio_intela_sites_digitalinternship_Page$SegmentKey();
    if ((x$3 === key)) {
      return this.sT;
    } else {
      return this.mw;
    }
  }
});
$p.vk = (function(index) {
  var this$3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_PartialFunction$Lifted(this.mv).cW(index);
  var this$4 = (this$3.k() ? $m_Lio_intela_sites_digitalinternship_data_Images$().mv.vZ() : this$3);
  return (this$4.k() ? $m_Lio_intela_sites_digitalinternship_data_Images$().mx : this$4.M());
});
var $d_Lio_intela_sites_digitalinternship_data_Images$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_data_Images$, "io.intela.sites.digitalinternship.data.Images$", ({
  f9: 1
}));
export { $d_Lio_intela_sites_digitalinternship_data_Images$ as $d_Lio_intela_sites_digitalinternship_data_Images$ };
var $n_Lio_intela_sites_digitalinternship_data_Images$;
function $m_Lio_intela_sites_digitalinternship_data_Images$() {
  if ((!$n_Lio_intela_sites_digitalinternship_data_Images$)) {
    $n_Lio_intela_sites_digitalinternship_data_Images$ = new $c_Lio_intela_sites_digitalinternship_data_Images$();
  }
  return $n_Lio_intela_sites_digitalinternship_data_Images$;
}
export { $m_Lio_intela_sites_digitalinternship_data_Images$ as $m_Lio_intela_sites_digitalinternship_data_Images$ };
//# sourceMappingURL=io.intela.sites.digitalinternship.data.-Images$.js.map
